export const COMPANY_DETAILS = {
  tradingName: 'VietClinics',
  legalName: 'Viet Medica Ltd',
  entityType: 'a private company limited by shares registered in Mauritius',
  registrationNo: '238949',
  registeredOffice: 'Sir William Newton Street, Curepipe, Mauritius',
  vietnamOperations: 'Ho Chi Minh City, Hanoi, Da Nang, Hoi An, Vung Tau and selected other locations across Vietnam. Services and provider availability vary by city and service.',
  phones: ['+230 57741437', '+84 38 6492508'],
  emails: ['nash.k@vietclinics.com', 'support@vietclinics.com'],
};

export const COMPANY_STATEMENT =
  `${COMPANY_DETAILS.tradingName} is the trading name of ${COMPANY_DETAILS.legalName}, ${COMPANY_DETAILS.entityType}.`;
